module.exports = __webpack_public_path__ + "static/06-5f104892b4b36bf0857054c3208ffea9.jpeg";